module.exports = __webpack_public_path__ + "img/activity.b5ce428d.png";